import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect, MDBTable, MDBTableBody, MDBTableHead,   } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption, } from "mdbreact";
import Axios from 'axios'
import { URL,api } from '../../api';
import Swal from 'sweetalert2'
import { Select,Result  } from 'antd';

export default class Modalarticleaddexpertdelete extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",
   id_send:"",
   send_uploadeword1:"",
   send_uploadepdf1:"",
   Expertmaparticle:[],

   duplicate : false, //ข้อมูลซ้ำ
}

//this.handleChange = this.handleChange.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.props.selectat();
}


 componentDidMount() {
      const { id_send } = this.props.id_send
      console.log(id_send);
       this.setState({ id_send:this.props.id_send})
       this.setState({ idExpert:this.props.id_expert})
 
  }


  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);

                    setTimeout(() => {

                       // event.preventDefault();
                        const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                        datafrm.append("idExpert", this.state.idExpert);
                        datafrm.append("idsend", this.state.id_send);

                        api.post("registercon/DeleteArticlemapexpert",datafrm,{
                            headers: {
                                'content-type': 'multipart/form-data'
                            }
                           })
                        .then(res => {
                        console.log("response: ", res)
                        if (res.data === '200') {
                        // this.showitem = true;
                                        console.log(res)
                                        console.log(res.data.length) 
                                        Swal.fire({
                                            title: 'ลบผู้ทรงคุณวุฒิสำเร็จ',
                                            text: "Successfully removed expert",
                                            icon: 'success',
                                            showCancelButton: false,
                                            confirmButtonColor: '#3085d6',
                                            cancelButtonColor: '#d33',
                                            confirmButtonText: 'ตกลง'
                                        }).then((result) => {
                                            if (result.isConfirmed) {
                                            // Swal.fire(
                                            //   'Deleted!',
                                            //   'Your file has been deleted.',
                                            //   'success'
                                            // )
                                            this.props.getExpertmaparticle();
                                            this.toggle()
                                            }
                                        })
                        }else{
                        // window.location.href = '/'
                        }
                    })

                    }, 500);
                
  }

  

    render() {
    //    console.log(this.state.idExpert)
    //    console.log(this.state.id_send)
        return (
            <MDBContainer>
            <MDBBtn color="danger" size='sm' onClick={this.toggle}>ลบ</MDBBtn>


            <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
              <MDBModalHeader toggle={this.toggle}>ลบข้อมูลผู้ทรงคุณวุฒิ  </MDBModalHeader>
              <MDBModalBody>
              <div>
              <Result
    status="error"
    title="ยืนยันลบข้อมูล"
    subTitle="ยืนยันลบข้อมูลผู้ทรงคุณวุฒิ"

  />
       
        {/* <select className="browser-default custom-select" onChange={this.handleChange}>
                   <option>------กรุณาเลือกผู้ทรงคุณวุฒิ------</option>
                   {this.state.Expert.map((Expert,index )  => 
                   <option value={Expert.id_expertbn}>{Expert.name_expertbn}</option>
                   )}
        </select> */}
        
        
              </div>
              </MDBModalBody>
              <MDBModalFooter>
                 <MDBBtn color="primary" onClick={this.handleSubmit} >ยืนยัน</MDBBtn>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                
              </MDBModalFooter>
            </MDBModal>
          </MDBContainer>
        )
    }
}
